<script setup lang="ts">
import type { FooterSocial } from '~/types/footer';

const props = defineProps<{
  data: FooterSocial;
}>();

const target = computed(() => {
  return props.data.targetBlank ? '_blank' : undefined;
});
</script>

<template>
  <a
    :href="data.url"
    :target
    :title="data.title"
    :aria-label="data.title"
    class="flex items-center rounded-xl bg-white-20 p-3 transition-colors hover:bg-white-10 focus:outline-none focus-visible:bg-white-10 focus-visible:outline-[2px] focus-visible:outline-white"
  >
    <BaseImage
      class="size-5"
      ratio="1/1"
      :data="data.icon"
      :skeleton="false"
      aria-hidden="true"
      link
    />
  </a>
</template>
